// Port of api/fuel/app/classes/filter/search/games/filters/query/collection/exclude/own.php
export default {
	name: 'collection.exclude.own',
	priority: 83,
	require: function(config, filter, data) {
		return filter.collection && filter.collection.exclude && filter.collection.exclude.own
	},
	run: function(config, filter, data, query) {
		query.where('ce.collection_own', '=', 1)
		query.notexist('collection', 'ce')
	}
}
